import { Stack, Typography, useTheme } from "@mui/material";
import { Accordian } from "components";
import { useGetAllChecklists } from "controller";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { ChecklistLibraryAccordian } from "./ChecklistLibraryAccordian";

export const ChecklistLibrarySection = forwardRef(
  (
    {
      selectedChecklist,
    }: {
      selectedChecklist: Array<any>;
    },
    ref,
  ) => {
    const theme = useTheme();
    const { data: checklists } = useGetAllChecklists({
      filter: [],
      sortColumn: "id",
      sortDirection: "asc",
    });

    const [currentSelectedChecklist, setCurrentSelectedChecklist] =
      useState<Array<any>>(selectedChecklist);

    const onSelectionChange = (selectedItem: any, isChecked: boolean) => {
      if (isChecked) {
        setCurrentSelectedChecklist([
          ...currentSelectedChecklist,
          selectedItem,
        ]);
      } else {
        setCurrentSelectedChecklist(
          currentSelectedChecklist.filter(
            (checklist: any) =>
              checklist.mapping_id !== selectedItem.mapping_id,
          ),
        );
      }
    };

    useImperativeHandle(ref, () => {
      return {
        submit: () => {
          return currentSelectedChecklist;
        },
      };
    });

    return (
      <Stack width={"100%"} sx={{ gap: "8px" }}>
        {Array.isArray(checklists?.result) &&
          checklists.result.map((checklist: any) => (
            <ChecklistLibraryAccordian
              key={checklist?.mapping_id}
              checklist={checklist}
              isSelected={Boolean(
                currentSelectedChecklist.find(
                  (item: any) => item.mapping_id === checklist.mapping_id,
                ),
              )}
              onSelectionChange={(isSelected) =>
                onSelectionChange(checklist, isSelected)
              }
            />
          ))}
      </Stack>
    );
  },
);
